@for (item of items; track item.id) {
  <li>{{ item }}</li>}
